import { useEffect } from "react";
import {
  isPromoCodeEnabled,
  isSubscriptionExpired,
} from "@/react/helpers/communityHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { usePunditUserContext } from "@circle-react/contexts";
import PlanSettings from "./PlanSettings/index";
import { PlusPlan } from "./PlusPlan/PlusPlan";

const updateSidebarAndPricingHeaderWhenExpired = ({
  isExpired,
  isCommunityOnPlus,
}: {
  isExpired: boolean;
  isCommunityOnPlus: boolean;
}) => {
  const pricingHeader = document.querySelector(".pricing-plans-table__header");
  const sidebar = document.querySelector(".standard-layout-v2__sidebar");

  if (pricingHeader instanceof HTMLElement) {
    pricingHeader.style.display = !isExpired ? "none" : "block";
  }
  if (sidebar instanceof HTMLElement) {
    const shouldHideSidebar = isExpired && !isCommunityOnPlus;
    sidebar.style.display = shouldHideSidebar ? "none" : "block";
  }
};

export const Plan = () => {
  const { isCommunityOnPlus } = usePlanStatus();
  const { currentCommunity } = usePunditUserContext();

  // [TODO][PlansPageRedesign][AfterRelease] Rename this key to a better name to represent locked state
  const isExpired =
    isSubscriptionExpired(currentCommunity) ||
    isPromoCodeEnabled(currentCommunity);
  useEffect(() => {
    updateSidebarAndPricingHeaderWhenExpired({ isExpired, isCommunityOnPlus });
  }, [isExpired, isCommunityOnPlus]);

  if (isCommunityOnPlus) {
    return <PlusPlan isExpired={isExpired} />;
  }

  return <PlanSettings isExpired={isExpired} />;
};

export default Plan;
